
import { PurchaseOrder, InspectionReportSummary, Defect } from './types';

export const COLORS = {
  blue: '#136bce',
  green: '#10b981',
  red: '#ef4444',
  yellow: '#f59e0b',
};

export const MOCK_POS: PurchaseOrder[] = [
  {
    id: '1',
    number: 'PO-2024-8901',
    customer: 'Zara International',
    location: 'Madrid, Spain',
    assignedTo: ['JS', 'SC'],
    shipDate: '15 Nov 2024',
    status: 'In Production',
    addedToday: true,
    inspections: { pilot: 'Passed', fabric: 'In Progress', line: 'Pending', final: 'Pending', container: 'Pending' },
  },
  {
    id: '2',
    number: 'PO-2024-8842',
    customer: 'H&M Global',
    location: 'Stockholm, Sweden',
    assignedTo: ['AL'],
    shipDate: '30 Oct 2024',
    status: 'Completed',
    inspections: { pilot: 'Passed', fabric: 'Passed', line: 'Passed', final: 'Passed', container: 'Passed' },
  },
  {
    id: '3',
    number: 'PO-2024-9005',
    customer: 'Uniqlo Co.',
    location: 'Tokyo, Japan',
    assignedTo: [],
    shipDate: '05 Dec 2024',
    status: 'Procurement',
    inspections: { pilot: 'Pending', fabric: 'Pending', line: 'Pending', final: 'Pending', container: 'Pending' },
  },
  {
    id: '4',
    number: 'PO-2024-8700',
    customer: 'Target Corp',
    location: 'Minneapolis, USA',
    assignedTo: ['MR'],
    shipDate: '10 Oct 2024',
    status: 'Shipped',
    inspections: { pilot: 'Passed', fabric: 'Passed', line: 'Passed', final: 'Passed', container: 'In Progress' },
  },
  {
    id: '5',
    number: 'PO-2024-8922',
    customer: 'Next Retail',
    location: 'London, UK',
    assignedTo: ['SJ'],
    shipDate: '22 Nov 2024',
    status: 'In Production',
    inspections: { pilot: 'Passed', fabric: 'Failed', line: 'Pending', final: 'Pending', container: 'Pending' },
  },
];

export const MOCK_REPORTS: InspectionReportSummary[] = [
  {
    id: 'INS-2023-0891',
    customerName: 'Zara Fashion',
    poNumber: 'PO-00891-ZF',
    intro: [{ status: 'Passed', date: '20 Oct 2023' }],
    duopro: [{ status: 'Passed', date: '22 Oct 2023' }],
    final: [{ status: 'In Progress', date: '25 Oct 2023' }],
  },
  {
    id: 'INS-2023-0885',
    customerName: 'H&M Global',
    poNumber: 'PO-00885-HG',
    intro: [{ status: 'Passed', date: '18 Oct 2023' }, { status: 'Failed', date: '15 Oct 2023' }],
    duopro: [{ status: 'Failed', date: '20 Oct 2023' }],
    final: [{ status: 'Pending', date: '-' }],
  },
  {
    id: 'INS-2023-0872',
    customerName: 'Uniqlo Co.',
    poNumber: 'PO-00872-UC',
    intro: [{ status: 'Passed', date: '15 Oct 2023' }],
    duopro: [{ status: 'Passed', date: '19 Oct 2023' }],
    final: [{ status: 'Passed', date: '24 Oct 2023' }],
  },
  {
    id: 'INS-2023-0868',
    customerName: 'Gap Inc.',
    poNumber: 'PO-00868-GP',
    intro: [{ status: 'Passed', date: '21 Oct 2023' }],
    duopro: [{ status: 'Scheduled', date: '26 Oct 2023' }],
    final: [{ status: 'Pending', date: '-' }],
  },
];

export const DEFECTS_BY_CATEGORY = [
  { name: 'Broken Yarn', count: 62, severity: 'High', percentage: 75 },
  { name: 'Oil Stains', count: 41, severity: 'Medium', percentage: 50 },
  { name: 'Weaving Error', count: 26, severity: 'High', percentage: 32 },
  { name: 'Dye Mismatch', count: 12, severity: 'Medium', percentage: 15 },
  { name: 'Needle Line', count: 9, severity: 'Low', percentage: 11 },
  { name: 'Other', count: 7, severity: 'Low', percentage: 8 },
];
